<template>
  <div>
    <!--
    <go-collapse :title="msg" :open="isMainOpen">
      <p>Le présent formulaire, dûment rempli, doit parvenir au bureau de la
        surveillance du domaine public de la Ville de Lausanne dans les délais minimums suivants:
      </p>
      <ul>
        <li>Fouille: 5 jours ouvrables avant les travaux.</li>
        <li>Echafaudage: 5 jours ouvrables avant l'installation.</li>
        <li>Echafaudage: 5 jours ouvrables avant l'installation.</li>
      </ul>
      <p>Pour plus d'informations veuillez vous rendre sur le
        <a
          href="http://www.lausanne.ch/lausanne-officielle/administration/finances-et-mobilite/routes-mobilite/domaine-public-utilisation-temporaire-du-domaine-public.html">
          site web de la Ville
        </a>
      </p>
    </go-collapse>
    -->
    <go-collapse :title="msg2" :open="isMainOpen">
      <p>
        Le requérant doit contacter le-la surveillant-e du domaine public, en charge du secteur sur lequel il souhaite obtenir un permis temporaire d'occupation du domaine public.
Lors de ce contact, il devra être en possession des informations suivantes :
      </p>
      <ul>
        <li>coordonnées complète (y compris adresse e-mail)</li>
        <li>numéro IDAFF (xxx'xxx), si les travaux sont mandatés par un gestionnaire de réseaux communal</li>
        <li>localisation des travaux</li>
      </ul>

      <p>
        <img src="../assets/plan.png"/>
        <a
          href="https://www.lausanne.ch/.binaryData/website/path/lausanne/prestations/mobilite-et-amenagements-publics/demande-permis-utilisation-temporaire-domaine-public/contentAutogenerated/autogeneratedContainer/col1/06/linkList/0/websitedownload/plan-des-secteurs-occupation-dp.2022-06-30-10-20-21.pdf"
          class="niceLink">Plan des secteurs et numéros de téléphone</a>
      </p>
      <p>
        Après ce contact obligatoire, le requérant recevra, par e-mail, un identifiant de demande unique. Ce code est indispensable pour effectuer la demande d'occupation temporaire du domaine public.
        <br/><br/>
        Vous trouverez de plus amples informations, comme par exemple les délais de demande,
        les tarifs ou encore les conditions d'usage du domaine public, sur le
        <a href="https://www.lausanne.ch/prestations/mobilite-et-amenagements-publics/demande-permis-utilisation-temporaire-domaine-public.html">
          site web de la Ville de Lausanne
        </a>
      </p>
      <br/><br/>
      <p>
        Si vous avez des questions, n'hésitez pas à nous contacter.<br/><br/>
        Nous répondons à vos appels du lundi au vendredi, de 08h00 à 11h30 et de 14h00 à 16h00.<br/><br/>
        <strong>Service de la mobilité et de l’aménagement des espaces publics</strong><br/>
        Surveillance du domaine public<br/><br/>
        Téléphones  <a href="tel:+41213155412">+41 21 315  5412</a> ou  <a href="tel:+41213155262">5262</a><br/>
        E-mail <a href="mailto:podp@lausanne.ch">podp@lausanne.ch</a><br/>
      </p>

<!--


      <h4>Sécurité des chantiers :</h4>
      <p>Avant de remplir la présente demande de permis, le requérant doit contacter la Police de Lausanne:</p>
      <ul>
        <li>M. Maillard au :<a href="tel:+41792069865">+41 79 206 9865</a></li>
        <li>M. Vauthey  au :<a href="tel:+41792106184">+41 79 210 6184</a></li>
      </ul>
      <p>pour la sécurité des chantiers, cette démarche est OBLIGATOIRE !</p>
      <h4>Surveillance du domaine public :</h4>
      <p>Le requérant contacte le surveillant du domaine public, avant de remplir la présente demande de permis (OBLIGATOIRE).<br>

      </p>
        <strong><span class="red-special">Attention</span></strong>
        <span class="red-special">: aucun permis ne sera délivré si ces démarches n'ont pas été effectuées !</span>
        -->
    </go-collapse>
  </div>
</template>

<script>
  import goCollapse from './ui/goCollapse'

  export default {
    name: 'home',
    components: {
      goCollapse
    },
    data: function () {
      return {
        msg: 'Demande de permis d\'utilisation temporaire du domaine public communal',
        msg2: 'Pour commencer ...',
        isMainOpen: true
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/Home.vue